// extracted by mini-css-extract-plugin
export default {"chessProject":"ChessProject_chessProject__v6kHq"};